module.exports = __webpack_public_path__ + "static/media/derecho-consumidor(3).6327aa34.jpg";